/**
 * External dependencies
 */
import { Icon } from '@jetpack-premium-analytics/externals';
import { jetpack } from '@jetpack-premium-analytics/icons';

export function StatsPageIcon() {
	return <Icon icon={ jetpack } size={ 24 } />;
}
